import { Tech, TechDiscriminatorKey } from './tech.model';
import { TechInsurance } from './tech-insurance.model';
import { TechBreaking } from './tech-breaking.model';
import { TechRelease } from './tech-release.model';
import { TechReturn } from './tech-return.model';
import { TechLoss } from './tech-loss.model';
import { Device } from './device.model';
import { isMongoId } from 'validator';

export class GeneralAggregatedTech {
  id?: string;
  device?: Device;
  docs?: (
    | TechInsurance
    | TechLoss
    | TechBreaking
    | TechReturn
    | TechRelease
    | Tech
  )[];

  constructor(json?: any) {
    if (!json) return;
    if (isMongoId(json.toString().trim())) {
      this.id = json.toString().trim();
      return;
    }
    this.id = json['_id'] || json['id'];
    this.device = json['device'] ? new Device(json['device']) : undefined;
    this.docs = (json['docs'] ?? []).map((jsonDoc: any) => {
      const docType: TechDiscriminatorKey = jsonDoc['__type'];
      switch (docType) {
        case 'insurance':
          return new TechInsurance(jsonDoc);
        case 'loss':
          return new TechLoss(jsonDoc);
        case 'breaking':
          return new TechBreaking(jsonDoc);
        case 'return':
          return new TechReturn(jsonDoc);
        case 'release':
          return new TechRelease(jsonDoc);
        default:
          return new Tech(jsonDoc);
      }
    });
  }
}
